import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TradeFilter } from "../../trading/trades/types";
import { DailyTradingReportFilter } from "./types";
import { PageIndex } from "../../models";

type TradesReportState = {
  filter: DailyTradingReportFilter;
  index: PageIndex;
};

export const initialState: TradesReportState = {
  filter: {
    reportDate: new Date().toISOString(),
  },
  index: {
    itemsPerPage: 20,
    pageNumber: 0,
  },
};

const name = "dailyTrade";

const dailyTrade = createSlice({
  name,
  initialState,
  reducers: {
    setIndex: (state, action: PayloadAction<PageIndex>) => ({
      ...state,
      index: action.payload,
    }),
    setReportData: (state, action: PayloadAction<string>) => ({
      ...state,
      filter: {
        reportDate: action.payload,
      },
    }),
    removeFilter: (state, action: PayloadAction<keyof TradeFilter>) => ({
      ...state,
      filter: {
        ...state.filter,
        [action.payload]: undefined,
      },
    }),
  },
});

export const { setReportData, removeFilter, setIndex } = dailyTrade.actions;

export default dailyTrade.reducer;
